/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Bidding_N_Battles__Answer_1Inputs */

const en_help_center__bidding_n_battles__answer_1 = /** @type {(inputs: Help_Center__Bidding_N_Battles__Answer_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can purchase more bid packages before your personal timer runs out. If not bought in time, you will be elimenated from the battle! Click the "Buy More Bids" button, select your package, complete payment in time and the bids will be instantly added to your account. We recommend purchasing enough bids before entering competitive battles.`)
};

/**
* | output |
* | --- |
* | "You can purchase more bid packages before your personal timer runs out. If not bought in time, you will be elimenated from the battle! Click the \"Buy More Bi..." |
*
* @param {Help_Center__Bidding_N_Battles__Answer_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__bidding_n_battles__answer_1 = /** @type {((inputs?: Help_Center__Bidding_N_Battles__Answer_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Bidding_N_Battles__Answer_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__bidding_n_battles__answer_1(inputs)
});